module.exports = __webpack_public_path__ + "static/media/shingleColonialSlate.6aba650c.png";